import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { FinanceSummaryComponent } from "../finance-summary/FinanceSummaryComponent";
const AccountList = () => {
    const [selectedAccount, setSelectedAccount] = useState();
    const handleOnSelectedAccount = (account) => {
        setSelectedAccount(account);
    };
    return (_jsx("div", { className: "accountslist-page", children: _jsx("section", { className: "container sub-wrap", children: _jsx(FinanceSummaryComponent, { account: selectedAccount, handleOnSelectedAccount: handleOnSelectedAccount }) }) }));
};
export default AccountList;
